import { Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import CustomUploader from "../../../../components/CustomUpload/CustomUploader";
import { useContext } from "react";
import ProfessionsAndSkillsContext  from "../../../../context/professionsAndSkillsContext";
import TextArea from "antd/es/input/TextArea";

function ProfessionAndSkillModal({ professionAndSkill }) {
  const { titleAction, descriptionAction } = useContext(ProfessionsAndSkillsContext);
  const [images, setImages] = useState([])
  const [videos, setVideos] = useState([])

  useEffect(()=> {
    if(professionAndSkill) {
      for(let i = 0; i < professionAndSkill?.files?.length; i ++) {
        let file = professionAndSkill?.files[i]
        
        if(file?.toLowerCase()?.endsWith('jpg') || file?.toLowerCase()?.endsWith('jpeg') || file?.toLowerCase()?.endsWith('png')) {
          setImages((prevState)=>[...prevState, file])
        } else {
          setVideos((prevState)=>[...prevState, file])
        }
      }
      titleAction(professionAndSkill?.title)
      descriptionAction(professionAndSkill?.description)
    }
  }, [professionAndSkill])

  return (
    <div>
      <Form layout="vertical">
        <div className="flex flex-row max-lg:flex-col justify-between gap-3">
          <section className="flex flex-col justify-start w-1/2 max-xl:w-full">
            <Form.Item label="عنوان حرفه و مهارت:">
              <Input className="text-xs rounded-lg  border-none"
                placeholder="عنوان را وارد کنید..."
                onChange={(e) => titleAction(e.target.value)}
                defaultValue={professionAndSkill?.title}
              />
            </Form.Item>
            <Form.Item label="توضیحات:">
              <TextArea style={{height:'120px'}} className="justify-start text-xs h-[200px]  border-none"
                placeholder="توضیحات خود را وارد کنید..."
                onChange={(e) => descriptionAction(e.target.value)}
                defaultValue={professionAndSkill?.description}
              />
            </Form.Item>
          </section>
          <section className="flex flex-col w-1/2 max-lg:w-full my-auto">
            <Form.Item className="w-full text-center shadow rounded-lg p-3">
              {<CustomUploader type='multiple-image' files={professionAndSkill?.files ? images : null}/>}
            </Form.Item>
            <Form.Item className="w-full text-center shadow rounded-lg p-3">
              {<CustomUploader type='multiple-video' files={professionAndSkill?.files ? videos : null}/>}
            </Form.Item>
            {/* <Form.Item className="w-full shadow text-left rounded-lg p-3">
            </Form.Item> */}
          </section>
        </div>
      </Form>
    </div>
  );
}

export default ProfessionAndSkillModal;
